import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Biometrics pages are only for companies that use biometrics (role 3 users are biometrics-only).
export default function BiometricsRoute() {
  const { user } = useAuth();
  const isBiometricsUser = user?.roleid === 3 || user?.roleid === '3';

  if (user?.company?.biometrics !== true && !isBiometricsUser) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
